<template>
    <div id="app">
        <loading />
        <popup />
        <router-view />
        <lanhu-dialog
            :showCancelButton="showCancelButton"
            :content="dialogText"
            :handleConfirm="goUpdate"
            :confirmButtonText="confirmButtonText"
            ref="dialog"
        />
    </div>
</template>

<script>
import lanhuDialog from "./components/common/lanhu-dialog"
import { Toast } from "mint-ui"
import popup from "@/components/base/Popup"
import loading from "@/components/base/Loading"
import appGo from "./common/js/appBack.js"
import { initWatermark } from './init/use-watermark.js';

import { clearTimeout } from "timers"
export default {
    name: "app",
    components: {
        loading,
        popup,
        lanhuDialog
    },
    data() {
        return {
            dialogText: "发现新版本",
            showCancelButton: true,
            confirmButtonText: "",

            apkUrl: ""
        }
    },
    mounted() {
        this.init()
        initWatermark(this.getTId());

        this.$root.eventBus.$on("resetSetting", this.resetSetting)
        this.$root.eventBus.$on("checkVersion", this.checkVersion)
    },
    methods: {
        getTId() {
            return this.$route.query.team_id || this.$route.query.teamId || this.$route.query.tid;
        },
        // 初始化方法
        async init() {
            var self = this
            var exit = 0
            localStorage.bann = "" //用于判断返回按钮是否禁用
            document.addEventListener(
                "deviceready",
                () => {
                    try {

                        document.addEventListener(
                            "backbutton",
                            () => {
                                if (self.$route.name == "team") {
                                    if (exit === 1) {
                                        navigator.app.exitApp() //退出app
                                    } else {
                                        exit++
                                        Toast({
                                            message: "再按一次退出蓝湖",
                                            position: "bottom",
                                            duration: 2500
                                        })
                                        setTimeout(() => {
                                            exit--
                                        }, 2500)
                                    }
                                    return
                                } else {
                                    appGo.goTo(self)
                                }
                            },
                            false
                        )

                        // alert(cordova.getAppVersion)
                        // alert(cordova.InAppBrowser)
                        this.checkVersion()
                        if (window.isWebview) {
                            StatusBar.show()
                            navigator.splashscreen.hide();
                            screen.orientation.lock("portrait")
                            // navigator.splashscreen.hide()
                        }
                        window.open = cordova.InAppBrowser.open
                    } catch (e) {
                        // alert(e.toString())
                    }
                },
                false
            )
        },
        //重置设置信息
        resetSetting() {
            localStorage.baseURL = ""
            let settingsData = window.setBase()
            let isWebview = settingsData.isWebview
            let useCustomServer = settingsData.useCustomServer
            this.$root.isWebview = isWebview
            this.$root.useCustomServer = useCustomServer
            window.axios.defaults.baseURL = settingsData.baseURL + "/api"
        },
        //检查新版本
        checkVersion() {
            var _this = this
            cordova.getAppVersion.getVersionNumber().then(async version => {
                localStorage.version = version
                var remoteVersion = await API.version.getInfo()
                this.apkUrl = remoteVersion.result ? remoteVersion.result.url : ""

                var localVersionNum = Number(version.split(".").join(""))
                var remoteVersionNum = Number(remoteVersion.result.version.split(".").join(""))

                if (localVersionNum < remoteVersionNum) {
                    setTimeout(() => {
                        if (window.system === "ios") {
                            _this.dialogText = "请前往appStore更新"
                            _this.confirmButtonText = "确定"
                            _this.showCancelButton = false
                            _this.$refs.dialog.openDialog()
                        } else if (window.system === "android") {
                            _this.dialogText = "发现新版本"
                            _this.showCancelButton = true
                            _this.confirmButtonText = "后台更新"
                            _this.$refs.dialog.openDialog()
                        }
                    }, 500)
                } else {
                    if (this.$route.name == "info") {
                        setTimeout(() => {
                            Toast({
                                message: "已经是最新版本",
                                position: "bottom",
                                duration: 1000
                            })
                        }, 500)
                    }
                }
            })
        },
        //以下为安卓平台下载更新相关方法
        goUpdate() {
            this.$refs.dialog.close()
            if (window.system === "ios") {
                let ref = cordova.InAppBrowser.open(
                    "itms-apps://itunes.apple.com/cn/app/id1164347415?mt=8",
                    "_system",
                    "location=yes"
                )
                return
            }
            this.$root.eventBus.$emit("showTip", "正在后台静默下载", "succeed")
            var _this = this
            window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, function(fs) {
                //创建文件
                fs.root.getFile("lanhuapp.apk", { create: true }, function(fileEntry) {
                    _this.download(fileEntry, _this.apkUrl)
                })
            })
        },
        download(fileEntry, url) {
            var ft = new FileTransfer()
            var _this = this
            var fileURL = fileEntry.toURL()
            //监听下载进度
            ft.onprogress = function(e) {
                console.info(e)
                if (e.lengthComputable) {
                    console.log("当前进度：" + e.loaded / e.total)
                }
            }
            ft.download(
                url,
                fileURL,
                function(entry) {
                    console.log("下载成功")
                    console.info(entry)
                    console.log("文件位置：" + entry.toURL())
                    _this.preview(fileEntry)
                },
                function(err) {
                    console.log("下载失败！")
                    console.info(err)
                },
                null
            )
        },
        preview(fileEntry) {
            var _this = this
            // 调用cordova-plugin-file-opener2插件实现用第三方app打开文件
            cordova.plugins.fileOpener2.showOpenWithDialog(
                // 此处必须填写cdvfile://地址，不然android7.0+会报文件权限错误
                fileEntry.toInternalURL(), //文件本地地址转cdvfile://地址
                "application/vnd.android.package-archive", //文件类型
                function onSuccess(data) {
                    console.log("成功预览:" + fileURL)
                },
                function onError(error) {
                    _this.toast("出错！请在" + cordova.file.externalDataDirectory + "目录下查看")
                }
            )
        }
    }
}
</script>

<style lang="scss">
@import "./assets/css/base.scss";
@import "./assets/css/lanhu-mint-ui.scss";

#app {
    font-family: PingFangSC-Regular, "PingFang SC", -apple-system, Roboto, "Microsoft YaHei";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #edeff1;
    height: 100%;
    width: 100%;
}
</style>
